import styled from '@emotion/styled';
import { Menu, MenuItem } from '@mui/material';
import { Text } from 'components';
import { colors } from 'styles/theme/colors';
export interface MenuOptionProps {
  label: string;
  endIcon?: JSX.Element;
  icon: JSX.Element;
  onClick: () => void;
}

interface ContextMenuProps {
  openMenu: boolean;
  options: MenuOptionProps[];
  onClose: () => void;
  menuPosition: { x: number; y: number };
  paperSx?: Record<string, unknown>;
  hoverStyles?: {
    backgroundColor?: string;
    useTextShadow?: boolean;
  };
}

export const ContextMenu = ({
  openMenu = false,
  options,
  onClose,
  menuPosition = { x: 0, y: 0 },
  paperSx,
  hoverStyles,
}: ContextMenuProps) => {
  const onMenuOptionClick = (event: React.MouseEvent<HTMLLIElement>, option: MenuOptionProps) => {
    event.stopPropagation();
    onClose();
    option.onClick();
  };
  return (
    <Menu
      onClose={onClose}
      open={openMenu}
      anchorPosition={{ top: menuPosition?.y, left: menuPosition?.x }}
      anchorEl={null}
      anchorReference="anchorPosition"
      MenuListProps={{ disablePadding: true }}
      slotProps={{
        paper: {
          sx: paperSx,
        },
      }}
    >
      {options.map((option, index) => (
        <StyledMenuItem
          key={option.label}
          color={colors.grey[700]}
          onClick={event => onMenuOptionClick(event, option)}
          hoverStyles={hoverStyles}
          hasEndIcon={!!option.endIcon}
        >
          {option.icon}
          <Text variant="labelSm" color="primary">
            {option.label}
          </Text>
          {option.endIcon}
        </StyledMenuItem>
      ))}
    </Menu>
  );
};

const StyledMenuItem = styled(MenuItem)<{
  hoverStyles?: { backgroundColor?: string; useTextShadow?: boolean };
  hasEndIcon?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px !important;
  padding: 6px 16px;

  ${p =>
    p.hasEndIcon &&
    `
    background-color: #EFF3F3;
    font-weight: 600;
  `}

  &:hover {
    ${p => p.hoverStyles?.backgroundColor && `background-color: ${p.hoverStyles.backgroundColor};`}
    ${p =>
      p.hoverStyles?.useTextShadow &&
      `
      text-shadow: 0 0 0.5px currentColor;
      .MuiTypography-root {
        text-shadow: 0 0 0.5px currentColor;
      }
    `}
  }
`;
